<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      key="index"
      class=""
      dense
      fixed-header
      mobile-breakpoint="300"
    >
      <template v-slot:top>
        <div class="d-flex justify-space-between align-center ps-6 py-3">
          <span class="mx-3 my-0 text-dark-50 font-size-h5 font-weight-bolder"
            >Features</span
          >

          <div class="w-400px">
            <v-text-field
              v-model="text"
              dense
              placeholder="Type feature and press enter"
              clearable
              outlined
              hide-details
              @keydown.enter="() => text && addItem(text)"
            />
          </div>
          <!--          <button-->
          <!--            type="submit"-->
          <!--            class="btn btn-light-info"-->
          <!--            @click="showAddItemModal"-->
          <!--          >-->
          <!--            New Item-->
          <!--          </button>-->
        </div>
      </template>

      <template v-slot:item.feature="{ value }">
        {{ value }}
      </template>

      <template v-slot:item.actions="{ item }">
        <!--        <v-icon small class="mr-2" @click="() => showEditSkuModal(item)">-->
        <!--          mdi-pencil-->
        <!--        </v-icon>-->
        <v-icon @click="() => removeItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <AddFeature ref="editItem" :actionFunction="addItem" />
  </div>
</template>

<script>
import AddFeature from "@/own/components/orderManagement/subscriptionPlans/featureTable/AddFeature.vue";
export default {
  name: "FeatureTable",
  props: ["setItems", "items"],
  components: { AddFeature },
  data: () => ({
    dialog: false,
    text: null,
    headers: [
      {
        text: "Feature",
        value: "feature",
        align: "start",
        class: "text-muted fw-bolder text-uppercase poppins-ls",
        cellClass: "text-dark-75 font-weight-medium poppins-ls",
      },
      {
        text: "Actions",
        value: "actions",
        align: "center",
        class: "text-muted fw-bolder text-uppercase poppins-ls",
        cellClass: "text-dark-75 font-weight-medium poppins-ls",
      },
    ],
  }),
  methods: {
    removeItem(item) {
      let new_items = [...this.items];
      let index = this.items.findIndex((it) => it.index === item.index);
      if (index > -1) {
        new_items.splice(index, 1);
        this.setItems(new_items);
      }
    },
    // showAddItemModal() {
    //   this.$refs.editItem.toggleModal();
    // },
    addItem(item) {
      let new_items = [...this.items];
      let index = this.items.findIndex((it) => it.feature === item);
      if (index === -1) {
        new_items.unshift({ feature: item, index: this.items.length + 1 });
        this.setItems(new_items);
        this.text = null;
      }
    },
  },
};
</script>
